import { FormattedMessage } from "react-intl";
import { CONTACT_EMAIL } from "./privacy/constants";

export default function Contact() {
    return(
        <div>
            <div className="navbar">
                <a href="/">
                    <img src="assets/pb_icon.png" alt=""/>
                </a>
                <a href="/" className="navbtn">
                    <FormattedMessage id="pureBudget"/>
                </a>
                <a href="/privacy" className="navbtn">
                    <FormattedMessage id="privacy"/>
                </a>
                <a href="/imprint" className="navbtn">
                    <FormattedMessage id="imprint"/>
                </a>
                <a href="/contact" className="navbtn active">
                    <FormattedMessage id="contact"/>
                </a>
            </div>
            <div className="centered main">
                <p className="featureCard">
                    <h2><FormattedMessage id="contactOnlyEmail"/></h2>
                    <p>
                        <span className="bold underlined italic"><FormattedMessage id="contactConsultHelp"/></span>
                    </p>
                    <p>
                        <FormattedMessage id="contactInfo0"/>
                        <ul>
                            <li><FormattedMessage id="contactInfo1"/></li>
                            <li><FormattedMessage id="contactInfo2"/></li>
                            <li><FormattedMessage id="contactInfo3"/></li>
                            <li><FormattedMessage id="contactInfo4"/></li>
                            <li><FormattedMessage id="contactInfo5"/></li>
                        </ul>
                    </p>
                </p>
                <a href={"mailto:"+CONTACT_EMAIL} className="contactBtn" target="_blank" rel="noreferrer"><FormattedMessage id="contactUs"/></a>
            </div>
        </div>
    );
}